import React from 'react';
import * as S from './styled';
import PlainButton from '../PlainButton';
import ModalTitle from '../ModalTitle';
import Backdrop from '../Backdrop';

const Modal = ({
  showFooter,
  title,
  acceptLabel,
  onAccept,
  onReject,
  children,
  ...others
}) => (
  <Backdrop onClick={onReject}>
    <S.ModalContainer>
      <S.Modal {...others}>
        {title && <ModalTitle title={title} />}
        <S.CloseIcon icon="fechar" onClick={onReject} />
        <S.ModalContent>{children}</S.ModalContent>
        {showFooter && (
          <S.ModalFooter>
            {acceptLabel && (
              <PlainButton inverse className="modalButton" onClick={onAccept}>
                {acceptLabel}
              </PlainButton>
            )}
          </S.ModalFooter>
        )}
      </S.Modal>
    </S.ModalContainer>
  </Backdrop>
);

export default Modal;
